
<template>
  <canvas style="display:none"></canvas>
</template>

<script>
import QRious from 'qrious'
export default {
  props: {
    text: { type: String, required: true },
    src: { type: String, required: false },
    size: { type: Number, required: false, default: 256 },
    color: { type: String, required: false, default: '#000' },
    bgColor: { type: String, required: false, default: '#FFF' }
  },
  watch: {
    text: function () {
      this.makeCode(this.text)
    }
  },
  mounted() {
    if (this.text) {
      this.makeCode(this.text)
    }
  },
  methods: {
    makeCode: function (text) {
      var qr = new QRious({
        element: this.$el,
        value: text,
        size: this.size
      })
      var parent = qr.canvas.parentNode
      var exist = parent.getElementsByTagName('img')[0]
      if (exist) parent.removeChild(exist)
      parent.appendChild(qr.image)
      this.$emit('update:src', qr.image.src)
    }
  }
}
</script>
